var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#paint0_linear_14823_29515)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0431 6.30273H17.6836C18.0275 6.30273 18.3603 6.42461 18.6229 6.64672L23.2421 10.5538C23.5689 10.8302 23.7573 11.2364 23.7573 11.6644V23.8381C23.7573 25.5744 23.7375 25.6967 21.9565 25.6967H10.0431C8.26202 25.6967 8.24219 25.5744 8.24219 23.8381V8.16132C8.24219 6.42504 8.26202 6.30273 10.0431 6.30273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7998 15.835H16.9026V13.8882C16.9026 13.6204 16.6855 13.4033 16.4178 13.4033H15.4255C15.1577 13.4033 14.9406 13.6204 14.9406 13.8882V15.835H13.0434C12.7757 15.835 12.5586 16.0521 12.5586 16.3199C12.5586 16.4346 12.5993 16.5456 12.6734 16.6331L15.5516 20.0326C15.7246 20.2369 16.0306 20.2623 16.2349 20.0893C16.2554 20.072 16.2743 20.053 16.2917 20.0326L19.1698 16.6331C19.3429 16.4288 19.3175 16.1228 19.1131 15.9498C19.0255 15.8757 18.9145 15.835 18.7998 15.835Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14823_29515",
    x1: 32,
    y1: 9.31104,
    x2: -1.61938,
    y2: 13.6949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22356C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212641"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatch);
export default __webpack_public_path__ + "static/media/Batch.1a06d61f9e1f2e963e4c58126d5131bc.svg";
export { ForwardRef as ReactComponent };